

  function uncheckGiftRadios() {
    var inputs = document.querySelectorAll('.js-radio-btns input');
    inputs.forEach(function (input) {
      input.checked = false;
    });
    $('.js-submit-btn').attr('disabled', 'true');
  }
  
  function initTabs() {
    if ($('.tabs').length == 0) {
      return;
    }
  
    var $tabsBtns = $('.tabs .tabs__nav a');
    $tabsBtns.on('click', function (event) {
      
      event.preventDefault();
      var $this = $(this);
      var target = $this.attr('href');
      $this.parent().addClass('is-active').removeClass('is-inactive').siblings().removeClass('is-active').addClass('is-inactive');
      $(target).addClass('is-active').siblings().removeClass('is-active');
      uncheckGiftRadios();
      $('.js-radio-btns li').removeClass('is-selected is-unselected');
    });
  }
  
  initTabs();
  
  function checkGiftRadios() {
    var $radioBtns = $('.js-radio-btns input');
    $radioBtns.on('change', function () {
      var $this = $(this);
      $this.closest('li').addClass('is-selected').removeClass('is-unselected').siblings().addClass('is-unselected').removeClass('is-selected');
      $('.js-submit-btn').removeAttr('disabled');
    });
  }
  
  //checkGiftRadios();
